import { request } from '@/shared/api/request'

export const getShortContractData = (id) => {
	return request({ url: `contract/labor/getShortContractData?externalId=${id}`, method: 'GET' })
}
